@if (isLogIn) {
  <div class="container">
    <span class="custom-badge">Usuario: {{ username }}</span>
  </div>
}

<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
          aria-expanded="false">Tests</a>
          <ul class="dropdown-menu">
            <!--<li><a class="dropdown-item" routerLink="/aplicaciones/liquidacion-web3" routerLinkActive="active">Liquidacion(Web3)</a></li>-->
            <li>
              <a class="dropdown-item" routerLink="/tests/tests" routerLinkActive="active">Tests</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/mysql" routerLinkActive="active">MySQL</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/mongo" routerLinkActive="active" >Mongo</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/couchbase" routerLinkActive="active" >CouchBase</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/angular" routerLinkActive="active" >Angular</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/kafka" routerLinkActive="active" >Kafka</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/vertx" routerLinkActive="active" >Vertx</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/hazelcast" routerLinkActive="active" >Hazelcast</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/python" routerLinkActive="active" >Python Flash</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/tests/typescript" routerLinkActive="active" >TypeScript Fastify</a>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/acercade" routerLinkActive="active">Acerca</a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            >
            Validadores
          </a>
          <ul class="dropdown-menu">
            <!--<li><a class="dropdown-item" routerLink="/aplicaciones/liquidacion-web3" routerLinkActive="active">Liquidacion(Web3)</a></li>-->
            <li>
              <a
                class="dropdown-item"
                routerLink="/validadores/rpc"
                routerLinkActive="active"
                >Cabeceras de bloque</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/validadores/sc"
                  routerLinkActive="active"
                  >Contrato inteligente</a
                  >
                </li>
              </ul>
            </li>
            <!--
            <li class="nav-item">
              <a class="nav-link" routerLink="/validadores" routerLinkActive="active">Validadores</a>
            </li>
            -->
            <li class="nav-item">
              <a class="nav-link" routerLink="/nodos" routerLinkActive="active"
                >Nodos</a
                >
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  >
                  Liquidacion
                </a>
                <ul class="dropdown-menu">
                  <!--<li><a class="dropdown-item" routerLink="/aplicaciones/liquidacion-web3" routerLinkActive="active">Liquidacion(Web3)</a></li>-->
                  <li>
                    <a
                      class="dropdown-item"
                      routerLink="/aplicaciones/liquidacion-ethers"
                      routerLinkActive="active"
                      >Inicio</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        routerLink="/aplicaciones/liquidacion-operaciones-pendientes"
                        routerLinkActive="active"
                        >Op. pendientes</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          routerLink="/aplicaciones/discrepancia"
                          routerLinkActive="active"
                          >Op. discrepantes</a
                          >
                        </li>
                      </ul>
                    </li>

                    <li class="nav-item dropdown">
                      <a
                        class="nav-link dropdown-toggle"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        >
                        Explorador de bloques
                      </a>

                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="dropdown-item"
                            routerLink="/block-explorer/bloques"
                            routerLinkActive="active"
                            >Bloques</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              routerLink="/block-explorer/transacciones"
                              routerLinkActive="active"
                              >Transacciones</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                routerLink="/block-explorer/transacciones-pendientes"
                                routerLinkActive="active"
                                >Transacciones pendientes</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  routerLink="/block-explorer/cuentas"
                                  routerLinkActive="active"
                                  >Cuentas de usuario</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    routerLink="/block-explorer/smart-contracts"
                                    routerLinkActive="active"
                                    >Smart Contracts</a
                                    >
                                  </li>
                                  @if (environment.exporador_api_plugin_extendido) {
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        routerLink="/block-explorer/tiempo"
                                        routerLinkActive="active"
                                        >Tiempo</a
                                        >
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          routerLink="/block-explorer/eventos"
                                          routerLinkActive="active"
                                          >Eventos</a
                                          >
                                        </li>
                                      }
                                      <li><hr class="dropdown-divider" /></li>
                                    </ul>
                                  </li>
                                  <li class="nav-item">
                                    <a class="nav-link" routerLink="/simulacion" routerLinkActive="active"
                                      >Simulación</a
                                      >
                                    </li>
                                    <li class="nav-item dropdown">
                                      <a
                                        class="nav-link dropdown-toggle"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        >
                                        Permisionado
                                      </a>
                                      <ul class="dropdown-menu">
                                        <li class="nav-item">
                                          <a
                                            class="nav-link"
                                            routerLink="/permisionado-cuentas/sc"
                                            routerLinkActive="active"
                                            >Permisionado Cuentas</a
                                            >
                                          </li>
                                          <li class="nav-item">
                                            <a
                                              class="nav-link"
                                              routerLink="/permisionado-nodos/sc"
                                              routerLinkActive="active"
                                              >Permisionado Nodos</a
                                              >
                                            </li>
                                          </ul>
                                        </li>

                                        <li class="nav-item dropdown">
                                          <a
                                            class="nav-link dropdown-toggle"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            >
                                            Back
                                          </a>
                                          <ul class="dropdown-menu">
                                            <li class="nav-item">
                                              <a
                                                class="nav-link"
                                                routerLink="/entidades"
                                                routerLinkActive="active"
                                                >Entidades</a
                                                >
                                              </li>
                                              <li class="nav-item">
                                                <a
                                                  class="nav-link"
                                                  routerLink="/cuentas"
                                                  routerLinkActive="active"
                                                  >Cuentas</a
                                                  >
                                                </li>
                                                <li class="nav-item">
                                                  <a
                                                    class="nav-link"
                                                    routerLink="/contratos"
                                                    routerLinkActive="active"
                                                    >Contratos</a
                                                    >
                                                  </li>
                                                  <li class="nav-item">
                                                    <a
                                                      class="nav-link"
                                                      routerLink="/auditoria"
                                                      routerLinkActive="active"
                                                      >Auditoria</a
                                                      >
                                                    </li>
                                                  </ul>
                                                </li>

                                                <li class="nav-item dropdown">
                                                  <a
                                                    class="nav-link dropdown-toggle"
                                                    role="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    >
                                                    Lott
                                                  </a>
                                                  <ul class="dropdown-menu">
                                                    <li class="nav-item">
                                                      <a
                                                        class="nav-link"
                                                        routerLink="/lottery"
                                                        routerLinkActive="active"
                                                        >Lottery</a
                                                        >
                                                      </li>
                                                      <li class="nav-item">
                                                        <a
                                                          class="nav-link"
                                                          routerLink="/lottery-erc20"
                                                          routerLinkActive="active"
                                                          >ERC20</a
                                                          >
                                                        </li>
                                                      </ul>
                                                    </li>

                                                    <li class="nav-item">
                                                      <a class="nav-link" routerLink="/desbloqueo" routerLinkActive="active"
                                                        >Desbloqueo</a
                                                        >
                                                      </li>
                                                      <li class="nav-item">
                                                        <a
                                                          class="nav-link"
                                                          routerLink="/administracion"
                                                          routerLinkActive="active"
                                                          >Administracion</a
                                                          >
                                                        </li>
                                                        <!-- <li class="nav-item">
                                                        <a
                                                          class="nav-link"
                                                          [class.disabled]="loginService.isLoggedIn | async"
                                                          routerLink="/login"
                                                          routerLinkActive="active"
                                                          >Login</a
                                                          >
                                                        </li> -->
                                                        <li class="nav-item">
                                                          <a
                                                            class="nav-link"

                                                            (click)="onLogout()"
                                                            routerLink="/"
                                                            >Logout</a
                                                            >
                                                          </li>

                                                          @if (loginService.isLoggedIn | async){
                                                            <span class="nav-link">Hola {{ loginService.loggedInuser }}</span>
                                                          }

                                                          <div class="input-group">
                                                            <span class="input-group-addon"
                                                              ><i class="glyphicon glyphicon-user"></i
                                                            ></span>

                                                            <input
                                                              type="text"
                                                              class="form-control"
                                                              value="{{ metaMaskService.currentAccount | async }}"
                                                              disabled
                                                              />
                                                          </div>
                                                          <form class="d-flex" role="search" [formGroup]="searchForm">
                                                            <input
                                                              class="form-control me-2"
                                                              type="search"
                                                              placeholder="Tx/Bloque/Cuenta"
                                                              aria-label="Search"
                                                              formControlName="search"
                                                              size="72"
                                                              />
                                                            <button
                                                              class="btn btn-outline-success"
                                                              type="submit"
                                                              (click)="searchBlockTransaction()"
                                                              >
                                                              Search
                                                            </button>
                                                          </form>
                                                          <button
                                                            class="btn btn-outline-success"
                                                            type="submit"
                                                            (click)="eth_requestAccounts()"
                                                            >
                                                            Metamask
                                                          </button>
                                                          @if (spinnerActive){
                                                            <mat-spinner [diameter]="70" [strokeWidth]="10"></mat-spinner>
                                                          }
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </nav>
